const Notifications = ()=>{
    return(
<span className="notify"><i className="fa fa-bell" aria-hidden="true"></i></span>
    );
}
export default Notifications;